export function setHexOpacity(hex = '', alpha) {
	const cleanHex = hex.replace('#', '');
	return `#${cleanHex}${Math.floor(alpha * 255).toString(16).padStart(2, 0)}`;
};
